import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=49fc49a6&scoped=true&"
import script from "./answerList.vue?vue&type=script&lang=js&"
export * from "./answerList.vue?vue&type=script&lang=js&"
import style0 from "./answerList.vue?vue&type=style&index=0&id=49fc49a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc49a6",
  null
  
)

export default component.exports